import React from 'react';
import { Box, LinearProgress, Typography } from '@mui/material';

interface Props {
  fullScreen?: boolean;
  label?: string;
}

const AppLoader: React.FC<Props> = (props: Props) => {
  const { fullScreen = false, label = 'Loading' } = props;

  const renderLoader = () => (
    <Box
      left="35%"
      position="absolute"
      textAlign="center"
      top="30%"
      width="25%"
    >
      <Typography variant="overline">{label}</Typography>
      <LinearProgress color="secondary" />
    </Box>
  );

  if (!fullScreen) {
    return renderLoader();
  }

  return (
    <Box bottom={0} left={0} position="fixed" right={0} top={0}>
      {renderLoader()}
    </Box>
  );
};

export default AppLoader;
